module.exports = __webpack_public_path__ + "static/media/foyer_4.5fc7775e.jpg";